import { AUTH_STORAGE_KEYS } from "../constants/authentication.constants";

/**
 * Single source of truth for reading/writing the auth token in
 * localStorage. The storage key ("ogm_token") is kept stable on purpose
 * so anything reading it directly keeps working.
 */

export const sessionStorageService = {
    get: () => localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN),
    set: (token) => localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, token),
    remove: () => localStorage.removeItem(AUTH_STORAGE_KEYS.TOKEN),
};

/** Fired on window when the backend rejects the stored token, so signed-in screens can switch to signed out. */
export const SESSION_EXPIRED_EVENT = "ogm:session-expired";

/** The token was refused (expired or revoked): forget it and tell the open screens. */
export const expireSession = () => {
    if (!sessionStorageService.get()) return;
    sessionStorageService.remove();
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

// Backward-compatible alias — prefer `sessionStorageService` in new code.
export const tokenStore = sessionStorageService;
